import { render, staticRenderFns } from "./AutorizacaoSuporte.vue?vue&type=template&id=61911444&"
import script from "./AutorizacaoSuporte.vue?vue&type=script&lang=js&"
export * from "./AutorizacaoSuporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports